// The purpose of this file is to properly instrument
// all form elements with FPTI beacons

import React from 'react'
import { TextInput } from '@paypalcorp/pp-react'
import fpti from '@paypalcorp/fpti'

// removes `_ga` param from URLs before sending to FPTI in the `pu` attribute
export const removeGAParam = (url: string) => {
  return url.replace(/([?&])_ga=[^&]+&?/, '$1').replace(/\?$/, '')
}

export const trackFptiEvent = ({ fptiData }: any) => {
  const defaultOptions = window?.PAYPAL?.analytics?.options?.data || {}
  const cleanedPu = removeGAParam(window?.location.href)
  fpti.record({
    data: {
      ...defaultOptions,
      ...fptiData,
      space_key: 'SKEXJE',
      pu: cleanedPu,
    },
  })
}

const fireFptiCall = (e: React.ChangeEvent, errorTextForFpti: string = '') => {
  const page = (window && window.fpti?.page?.replace(/[-:]/g, '_')) || 'unknown'
  const eventType = e.type
  const target = e.target as HTMLInputElement
  const eventTargetName = target.name

  function setEventType(
    eventType: string | undefined,
    targetType: string | undefined,
    errorTextForFpti: string,
  ) {
    if (eventType === undefined) {
      return ''
    }
    if (errorTextForFpti) {
      return 'field_exit'
    }
    const map: Record<string, string> = {
      focus: 'field_focus',
      blur: 'field_exit',
      click: targetType === 'submit' ? 'button_pressed' : 'field_click',
    }
    return map[eventType] ?? `field_${eventType}`
  }

  trackFptiEvent({
    fptiData: {
      e: eventType,
      page_name: page,
      field_name: eventTargetName || 'null',
      event_name: `devexp_${page}_field_${setEventType(
        eventType,
        target.type,
        errorTextForFpti,
      )}`,
    },
  })
}

const errorFptiCall = (errorTextForFpti: string, fieldName: string) => {
  const page = (window && window.fpti?.page?.replace(/[-:]/g, '_')) || 'unknown'

  trackFptiEvent({
    fptiData: {
      e: 'error',
      field_name: fieldName,
      error_message: errorTextForFpti,
      event_name: `devexp_${page}_field_error`,
      page_name: page,
    },
  })
}

export interface TextInputWrapperProps {
  nameValue: string
  errorPresent: boolean
  errorTextForFpti: string
  [key: string]: any // Allows additional props to be passed
}

export const TextInputWrapper: React.FC<TextInputWrapperProps> = (props) => {
  const { nameValue, errorPresent, errorTextForFpti, ...rest } = props

  if (errorPresent) {
    errorFptiCall(errorTextForFpti, nameValue)
  }

  return (
    <TextInput
      name={nameValue}
      onFocus={fireFptiCall}
      onBlur={fireFptiCall}
      {...rest}
    />
  )
}
